<template>
	<div class="contianer main-content">

		<div class="row">
			<div class="col-12 header-container text-center pb-3">
				<div class="checkmark" alt="Checkmark"></div>
			</div>
			
			<div class="col-12 header-container text-center pb-2">
				<h2 class="lrg primary-highlight">
					<template v-if="showWallet">
						Your information has been verified.
					</template>
					<template v-else>
						Thank you.  Your order has been received.
					</template>
					
				</h2>
			</div>

			<div class="col-12 text-center">
				<img src="./../assets/img/shadow_bottom.png" alt="shadow">
			</div>
		</div>

		<template v-if="!checkingStatus">
			
			<template v-if="showWallet">
				<div class="row">
					<div class="col-12 pt-2 text-center">

						<div class="row mt-2 mb-3">
							<div class="col-12 offset-0 col-md-8 offset-md-2 p-4 pl-5 pr-5 text-center alert alert-timer">
								Please send your crypto payment to our address below.  Once funds have been received, your gift card will be sent to your email.
							</div>
						</div>

						<img width="250" height="250" :src="'/pubapi/qrcode/walletaddress/' + this.pq.refId" />

						<div class="row mt-2 mb-3">
							<div class="col-12 text-center">
							<h3 class="mt-3 mb-3 crypto-payment-address">{{ cryptoAddress }}</h3>

							<p class="amount-to-send">Amount to send</p>

							<h4>{{ cryptoAmount }}&nbsp;{{ cryptoCurrency }}</h4>
							</div>
						</div>
						
					</div>
				</div>
			</template>
			<template v-else>

				<div class="row">
					<div class="col-12 pt-4 text-center">
						<img :src="gcImage" :alt="$gstate.getPaymentMethodName(this.$gstate.getPaymentMethod()) + ' eGift Card'">
					</div>
				</div>

				<div class="row">
					<div class="col-12 pt-4 text-center">
						<h4 class="dark-highlight"><strong>${{ pq.fiatAmount | num2decimal }} <small>{{ pq.fiatCurrency }}</small> {{ $gstate.getPaymentMethodName(this.$gstate.getPaymentMethod()) }} eGift Card</strong></h4>
					</div>
				</div>


				<div class="row panel-warning mt-4 mb-5 p-3">
					<div class="col-12 col-sm-1 text-center">
						<div class="exclamation" alt="Exclamation"></div>
					</div>
					<div class="col-12 col-sm-11 text-center text-warning">
						Once your personal information has been verified, payment instructions will be sent to <strong>{{ bi.emailAddress }}</strong>.
					</div>
				</div>

			</template>

			<div class="row mt-4">
				<div class="col-12 text-center">
					<a href="#" id="payment-flexepin-success-next" class="btn next-btn" v-on:click.prevent="done">
						<template v-if="showWallet">
							Next
						</template>
						<template v-else>
							Done
						</template>
						
					</a>
				</div>
			</div>

		</template>
		
		<template v-if="checkingStatus">
			<div class="row">
				<div class="col-12 pt-4 text-center">
					<i class="fas fa-circle-notch fa-spin"></i>
				</div>
			</div>
		</template>

		<cc-modal v-if="showConfirmModal" v-bind:confirm="true" @action="actionModal">
			<h3 slot="header">Confirm</h3>
			<p slot="body">Have you sent your crypto to our provided address?</p>
		</cc-modal>
		
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
    data() {
        return {
			pq: this.$gstate.getFlowState(),
			bi: this.$gstate.getBuyerInfo(),
			address: this.$gstate.getCryptoAddress(),
			checkingStatus: true,
			showWallet: false,
			retryCount: 0,
			cryptoAddress: null,
			cryptoCurrency: null,
			cryptoAmount: null,
			showConfirmModal: false
        }
	},
	mounted() {
		this.$emit('setLeaveNotification', false);
		eventBus.$emit('logGTMTransactionEvent', "transactionComplete");
		this.checkStatus();
	},
	created(){
        this.$emit('setRateHoldTimer', false);
    },
    methods: {
		checkStatus: function(){
		
			var urlstr = this.$gstate.getApiBaseURL() + '/status/=' + this.pq.refId;

			this.axios.get(urlstr) 
				.then(response => {

					if(response.data.txnStatus != 'PROCESSED'){
						// try again
						this.retryCount++;
						if(this.retryCount <= 2){
							setTimeout(() => {
								this.checkStatus();
							}, 2000);
							return;
						} else {
							this.checkingStatus = false;
						}
					} else {
						this.cryptoAddress = response.data.cryptoAddress;
						this.cryptoCurrency = response.data.cryptoCurrency;
						this.cryptoAmount = response.data.cryptoAmount;
						this.showWallet = true;
					}

					this.checkingStatus = false;

				})
				.catch(error => {
					this.$gstate.log(error.response);
					
				});

		},
        done: function (){
			if(this.showWallet){
				this.showConfirmModal = true;
			} else {
				this.$emit('reset', false);
				this.$gstate.redirectSuccess();
			}
		},
		actionModal: function(action){
			if(action == "yes"){
				this.$router.push('payment-spend-success');
			} else {
				this.showConfirmModal = false;
			}
		}
	},
	computed: {
		gcImage: function(){
			return '/static/img/sell/' + this.$gstate.getPaymentMethod() + '.png';
		}
	},
}
</script>